import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AccountEdit } from './components';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const AccountInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.account);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Account Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Username</TableCell>
              <TableCell>{model.username}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Display Name</TableCell>
              <TableCell>{model.displayname}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Email</TableCell>
              <TableCell>{model.email}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Phone</TableCell>
              <TableCell>{model.phone}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <AccountEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

AccountInfo.propTypes = {
  className: PropTypes.string,
};

export default AccountInfo;
